//Scroll
window.addEventListener("scroll", (ev) => {
    const scrollPosition = window.scrollY;
    if (scrollPosition > 0) {
        document.body.classList.add('scrolled');
    } else {
        document.body.classList.remove('scrolled');
    }
});